import { isElectron } from '../../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { FormAutocompleteProps } from './FormAutocomplete.types';
import { KioskFormAutocomplete } from './KioskFormAutocomplete/KioskFormAutocomplete';
import { WebFormAutocomplete } from './WebFormAutocomplete/WebFormAutocomplete';
import { KeyboardLayouts } from '../../../SimpleKeyboard/Layout';

const FormAutocomplete = <T,>({
    name,
    id,
    title,
    label,
    ariaLabel,
    labelClass,
    disabled,
    options,
    forceBottomPopper,
    clearOnBlur = false,
    keyboardLayout = KeyboardLayouts.Alphanumeric,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    shiftAfterSpace = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
}: FormAutocompleteProps<T>) => {
    return isElectron() ? (
        <KioskFormAutocomplete
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            labelClass={labelClass}
            disabled={disabled}
            options={options}
            forceBottomPopper={forceBottomPopper}
            clearOnBlur={clearOnBlur}
            keyboardLayout={keyboardLayout}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            shiftAfterSpace={shiftAfterSpace}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
        />
    ) : (
        <WebFormAutocomplete
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            labelClass={labelClass}
            disabled={disabled}
            options={options}
            forceBottomPopper={forceBottomPopper}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
        />
    );
};

export default FormAutocomplete;